import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomSelect from "../CustomComponents/CustomSelect";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import Tooltip from '@mui/material/Tooltip';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import {checkAuthentication} from '../../utils';

export default function EditLabsDialog({ handleEditCallback, data }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    

    const initialValues = {
        LabName: data.Name,
        IsActive: data.IsActive ? true : false
    };

    const validFormSchema = Yup.object({
        LabName: Yup
            .string('Enter a Lab ID')
            .required('Lab ID is Required'),
        IsActive: Yup
            .boolean()
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            ID: data.ID,
            Name: values.LabName,
            IsActive: values.IsActive
        };

        handleEditCallback(msg);
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {
		checkAuthentication();

    })

    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Tooltip title="Edit" placement="top-end">
                <IconButton variant="contained" onClick={handleClickOpen}>
                    <BorderColorRoundedIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Edit Lab
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Lab Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="LabName"
                                            variant="outlined"
                                            id="outlined-labName"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.LabName}
                                            error={props.touched.LabName && Boolean(props.errors.LabName)}
                                            helperText={props.touched.LabName && props.errors.LabName}                                          
                                            label="Lab Name"
                                        />
                                    </FormControl>
                                </div>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="IsActive"
                                            label="Active"
                                            control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>                
            </Dialog></MuiThemeProvider>
        </div>
    );
}